import React from 'react'
import {Grid,Card} from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { selectOneState, displayInvoiceList, displaySingleInvoice, displayMainUtilityView, resetOneSlice } from '../../../../../features/oneMobile/oneSlice';
import {selectGlobalDataState, setGeneralMessage, setTransactionHasBeenMade} from '../../../../../features/global/globalDataSlice'
import {selectMyContractsState, resetSelectedContractInfo} from '../../../../../features/myContracts/myContractsSlice'
import smallLoadingAnimation from '../../../../../icons/lottieAnimations/smallLoading.json'
import SingleExpandedInvoice from '../SingleExpandedInvoice'
import One from './One'
import OneInvoiceList from './OneInvoiceList'
import Lottie from "lottie-react";
import { selectUserInfo } from '../../../../../features/userInfo/userInfoSlice';
import MyContractsTest from '../myContracts/myContractsNew/MyContractsTest';
import { texts } from '../../../../general/texts';

const UtilityOne = (props) => {
    const oneSliceState = useSelector(selectOneState) 
    const globalDataSliceState = useSelector(selectGlobalDataState)
    const myContractsSliceState = useSelector(selectMyContractsState)
    const dispatch = useDispatch()
    const userInfo = useSelector(selectUserInfo)
    const utilityName = 'TELEKOM ALBANIA'

    React.useEffect(()=>{
        oneSliceState.shouldDisplaySingleInvoice && dispatch(displaySingleInvoice())
        oneSliceState.shouldDisplayInvoiceList && dispatch(displayInvoiceList())
        oneSliceState.shouldDisplayMainUtilityView && dispatch(displayMainUtilityView())
        
        if(oneSliceState.isOfferTransactionSuccessfullyCompleted)
        {
            dispatch(setTransactionHasBeenMade(true))
            dispatch(setGeneralMessage({type: 'success', message: texts["message-success-trx"]}))
            dispatch(resetOneSlice())
        }

        return(() => {
            dispatch(resetSelectedContractInfo())
        })
    },[oneSliceState.isOfferTransactionSuccessfullyCompleted, oneSliceState.shouldDisplaySingleInvoice, oneSliceState.shouldDisplayInvoiceList, oneSliceState.shouldDisplayMainUtilityView])

    return(
        <Grid container spacing={'2%'} pt={'3%'} >
            <Grid container item md={6.5} justifyContent={'right'} sx={{'@media (max-width: 899px)' : {justifyContent:'center'}}} >
                <Card sx={{borderRadius:'20px',boxShadow:'0 0 15px 5px #E5E7EA', width:'60%', '@media (max-width: 1440px )' : {width:'70%'}, '@media (max-width: 1320px )' : {width:'90%'}}}>
                        {oneSliceState.shouldDisplayInvoiceList === false && oneSliceState.shouldDisplaySingleInvoice === false && <One selectedContractInfo={myContractsSliceState.selectedContractInfo} utilityName={utilityName} defaultButtonStyle={props.defaultButtonStyle} selectedButtonStyle={props.selectedButtonStyle} oneSliceState={oneSliceState} utilityInfo={props.utilityInfo} globalDataSliceState={globalDataSliceState}/>}
                        {oneSliceState.shouldDisplayInvoiceList === true && <OneInvoiceList utilityInfo={props.utilityInfo} utilityName={utilityName} globalDataSliceState={globalDataSliceState} oneSliceState={oneSliceState}/>}  
                        {oneSliceState.shouldDisplaySingleInvoice === true && <SingleExpandedInvoice utilityName={utilityName} invoice={oneSliceState.singleInvoice} globalDataSliceState={globalDataSliceState} oneSliceState={oneSliceState}/>}  
                        <Grid container justifyContent={'center'}>
                        <Grid item md={3} xs={3}>
                        {oneSliceState.isLoading && <Lottie animationData={smallLoadingAnimation} loop={true} autoplay={true}/>}</Grid>
                    </Grid> 
                                 
                    </Card>            
                </Grid>
                <Grid container item md={4.5} justifyContent={'left'} sx={{'@media (max-width: 899px)' : {justifyContent:'center'}}} > 
                    <MyContractsTest utilityName={utilityName} currentLocation='utility'/>
                </Grid>
        </Grid> 
    )
}

export default UtilityOne